<template>
  <BrandList :portal-company="portalCompany"/>
</template>

<script>
import BrandList from "../../../../../../components/Companies/Brands/Panels/List"

export default {
  components: {BrandList},

  props: {
    portalCompany: {
      required: true
    }
  }
}
</script>
